import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { client } from './net/client';
import { applyInitialTheme } from './lib/settings';
import { App } from './ui/App';
import './styles.css';
import './pages.css';

applyInitialTheme();
client.connect();
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
